import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiCAccountBalanceModule } from '@wlp/ui-c-account-balance';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCHeaderPixService = class UiCHeaderPixService {
    constructor() {
        this.disableButton = false;
        this.disableButton$ = new Subject();
        this.initObservable();
    }
    // inicio do observable
    initObservable() {
        this.disableButton$.subscribe(res => this.disableButton = res);
    }
    // retorna o observable
    createObservable() {
        return this.disableButton$.asObservable();
    }
    // atualiza o status cpf
    updateStatus(value) {
        this.disableButton$.next(value);
    }
    getStatus() {
        return this.disableButton;
    }
};
UiCHeaderPixService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCHeaderPixService_Factory() { return new UiCHeaderPixService(); }, token: UiCHeaderPixService, providedIn: "root" });
UiCHeaderPixService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], UiCHeaderPixService);

let UiCHeaderPixComponent = class UiCHeaderPixComponent {
    constructor(service) {
        this.service = service;
        this.showBLC = false;
        this.goBack = new EventEmitter();
        this.iconName = 'eye-off-outline';
        this.type = 'onboard';
        this.backButton = true;
        this.altText = 'brand image';
        this.disableBack = this.service.getStatus();
    }
    set disableBackBtn(value) {
        this.disableBack = value;
        this.service.updateStatus(value);
    }
    ngOnInit() { }
    goBackButton() {
        if (!this.disableBack) {
            this.goBack.emit();
        }
    }
    showBalance() {
        if (this.iconName === 'eye-off-outline') {
            this.iconName = 'eye-outline';
            this.showBLC = true;
        }
        else {
            this.iconName = 'eye-off-outline';
            this.showBLC = false;
        }
    }
};
UiCHeaderPixComponent.ctorParameters = () => [
    { type: UiCHeaderPixService }
];
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "altText", void 0);
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "imagePath", void 0);
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "backButton", void 0);
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "backgroundImage", void 0);
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "type", void 0);
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "mode", void 0);
__decorate([
    Input()
], UiCHeaderPixComponent.prototype, "balance", void 0);
__decorate([
    Output()
], UiCHeaderPixComponent.prototype, "goBack", void 0);
__decorate([
    Input('disableBackBtn')
], UiCHeaderPixComponent.prototype, "disableBackBtn", null);
UiCHeaderPixComponent = __decorate([
    Component({
        selector: 'ui-c-header-pix',
        template: "<ion-header [ngClass]=\"'ion-header ion-header-' + type + ' ion-no-border'\">\n  <ion-toolbar class=\"ion-toolbar\">\n    <ion-grid class=\"ion-grid ion-no-padding\"\n      [style.background-image]=\"type === 'logon' ? 'url(' + backgroundImage + ')' : ''\">\n      <ion-row [ngClass]=\"mode === 'balance' ? 'ion-row ion-align-items-center ion-justify-content-center row-img-pix' : 'ion-row ion-align-items-center ion-justify-content-center'\">\n        <ng-container>\n          <ion-col\n            class=\"pix-title-logo ion-col d-flex ion-text-center ion-align-items-center ion-justify-content-center\"\n              size=\"6\">\n            <ion-img [ngClass]=\"mode === 'balance' ? 'ion-img' : 'ion-img'\" [src]=\"imagePath\" [alt]=\"altText\">\n            </ion-img>\n            <span class=\"font-family-bold ml-2 title-pix\">{{'PIX.DASHBOARD.HEADER.TITLE'| wlpTranslate}}</span>\n          </ion-col>\n        </ng-container>\n\n         <ng-container *ngIf=\"mode != 'balance'\" >\n          <ion-col  class=\"ion-col d-flex ion-text-center ion-align-items-center ion-justify-content-center\" [size]=\"mode != 'full' ? 12 : 8\">\n            <span [ngClass]=\"!backButton ? 'title mode-text' : 'title'\">\n              <ng-content></ng-content>\n            </span>\n          </ion-col>\n        </ng-container> \n\n\n      </ion-row>\n\n    </ion-grid>\n\n  </ion-toolbar>\n  <div *ngIf=\"mode != 'text'\" class=\"balance-header-pix\">\n    <ui-c-account-balance class=\"w-100\" [textTitle]=\"'Saldo'\" (clickEvent)=\"showBalance()\" [iconName]=\"iconName\"\n      [showBLC]=\"showBLC\">\n      <ion-text class=\"ion-text-left font-size-20\">\n        <span> {{balance | currency:'BRL'}} </span>\n      </ion-text>\n    </ui-c-account-balance>\n  </div>\n</ion-header>\n",
        styles: [""]
    })
], UiCHeaderPixComponent);

let UiCHeaderPixModule = class UiCHeaderPixModule {
};
UiCHeaderPixModule = __decorate([
    NgModule({
        declarations: [UiCHeaderPixComponent],
        imports: [
            IonicModule,
            CommonModule,
            UiCAccountBalanceModule,
            UiBsTranslateModule
        ],
        providers: [UiCHeaderPixService],
        exports: [UiCHeaderPixComponent]
    })
], UiCHeaderPixModule);

/*
 * Public API Surface of ui-c-dashboard-header-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCHeaderPixComponent, UiCHeaderPixModule, UiCHeaderPixService };
//# sourceMappingURL=wlp-ui-c-header-pix.js.map
